import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Protected Route Component
 * Redirects based on user role
 */
const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { user, userRole, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (requiredRole && userRole !== requiredRole) {
    if (userRole === 'DISABLED') {
      return <Navigate to="/" replace state={{ message: 'Account disabled. Please contact support.' }} />;
    }
    if (userRole === 'ADMIN') return <Navigate to="/admin-dashboard" replace />;
    if (userRole === 'SALES_PARTNER') return <Navigate to="/partner" replace />;
    if (userRole === 'WEBSITE_OWNER') return <Navigate to="/owner" replace />;
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
